import React, { useContext } from "react";
import { OperatorBulkEditActivity } from "app/userManagement/modules/operator/features";
import { ProviderBulkEditActivity } from "app/userManagement/modules/provider/features";

import { storageHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";
import constant from "lib/constant/constant";

const { userKey } = constant;
const { operator, provider } = userKey;

const BulkEditActivity = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorBulkEditActivity />;
    }
    if (role === provider) {
      return <ProviderBulkEditActivity />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const BulkActivityComponent = getComponent(currentUserRole);
  return BulkActivityComponent;
};

export default BulkEditActivity;
